export default __webpack_public_path__ + "static/media/8174-vote.6f31e6fb.gif";